import { Units } from "@/enums/units.enum"

export function getUnitList() {
  return Object.entries(unitNames).map(([key, value]) => {
    const enumKey = key as unknown as Units
    return {
      key: Number(key),
      value,
      alternative: unitAlternativeNames[enumKey] ?? ""
    }
  })
}

export function unitToName(unit: Units) {
  return unitNames[unit]
}

export function unitToAlternativeName(unit: Units) {
  return unitAlternativeNames[unit] ?? ""
}

const unitNames: { [key in Units]: string } = {
  [Units.PIECE]: "stuks",
  [Units.TONNE]: "ton",
  [Units.KILOGRAM]: "kg",
  [Units.CUBIC_METER]: "m³",
  [Units.LITER]: "l",
  [Units.METER]: "m",
  [Units.HOUR]: "uur",
  [Units.DAY]: "dag",
  [Units.SQUARE_METER]: "m²"
}

const unitAlternativeNames: { [key in Units]?: string } = {
  [Units.CUBIC_METER]: "m3",
  [Units.SQUARE_METER]: "m2"
}
